/**
 * Turn a failed upload into something the person uploading can act on.
 *
 * "Upload failed" on its own sent people hunting through the file and through
 * InDesign for a fault that was neither - the service already knew the storage
 * was unreachable and said so, and that message was being discarded here.
 *
 * Kept as a plain function so the behaviour can be tested without mounting the
 * whole selector.
 */
export const uploadErrorMessage = (error: unknown): string => {
  const detail = (
    error as { response?: { data?: { message?: unknown } } } | undefined
  )?.response?.data?.message

  // Nest sends `message` as a string, or as an array for validation errors.
  const text = Array.isArray(detail)
    ? detail.filter((item) => typeof item === 'string' && item.trim()).join(' ')
    : detail

  return typeof text === 'string' && text.trim()
    ? `Upload failed: ${text.trim()}`
    : 'Upload failed'
}
